<template>
  <div class="page-content">
    <AppNavbar
      v-if="!isWx"
      :placeholder="true"
      :options="options"
      :zIndex="20"
      :title="options.title"
    >
    </AppNavbar>
    <div class="container" v-if="dietData">
      <div class="c-top">
        <!-- 用户信息 -->
        <div class="user-info c-padding">
          <img class="avatar" :src="dietData.head_img" alt="" />
          <div class="user-right">
            <p class="name"
              ><span class="truename">{{ dietData.truename }}</span></p
            >
            <p class="camp"
              ><span class="nickname" v-if="dietData.nickname"
                >({{ dietData.nickname }})</span
              ></p
            >
          </div>
        </div>
        <!-- 标签列表 -->
        <div class="tag-container c-padding" v-if="sevenTagData.list.length">
          <div class="tag-list" :class="{ maxheight: !sevenTagData.openTag }">
            <div
              class="tag-item"
              v-for="(item, index) in sevenTagData.list"
              :key="index"
            >
              <span :class="['tag-color-' + item.type]">{{
                item.label_name
              }}</span
              ><span class="tag-num">{{ item.label_num }}次</span>
            </div>
          </div>
          <div
            class="open-tag"
            @click="bindOpenTag(sevenTagData)"
            v-if="sevenTagData.list.length > 5"
          >
            <span>{{ sevenTagData.openTag ? '收起' : '展开更多' }}</span
            ><span class="iconfont icon-black"></span>
          </div>
        </div>
        <!-- 用户标签 -->
        <div class="tag-container c-padding" v-if="userTagData.list.length">
          <div class="tag-list" :class="{ maxheight: !userTagData.openTag }">
            <div
              class="tag-item"
              :class="['user-tag-' + item.attr]"
              v-for="(item, index) in userTagData.list"
              :key="index"
            >
              <span>{{ item.tag_name }}</span>
            </div>
          </div>
          <div
            class="open-tag"
            @click="bindOpenTag(userTagData)"
            v-if="userTagData.list.length > 5"
          >
            <span>{{ userTagData.openTag ? '收起' : '展开更多' }}</span
            ><span class="iconfont icon-black"></span>
          </div>
        </div>
        <!-- 餐卡信息 -->
        <div class="diet-image-container">
          <div class="d-list">
            <img
              class="d-item"
              v-for="(item, index) in dietData.meal_img"
              :key="index"
              :src="
                formatImageUrl(
                  item + '?x-oss-process=image/resize,w_300/quality,Q_80'
                )
              "
              alt=""
              @click="previewImage(dietData.meal_img, index)"
            />
          </div>
        </div>
        <div class="diet-info c-padding">
          <div class="diet-title" v-if="dietData.title">
            {{ dietData.title }}
          </div>
          <div class="diet-desc">
            {{ dietData.meal_content }}
          </div>
          <!-- 用户选择信息 -->
          <div class="select-info">
            <div
              class="select-info-item"
              v-if="dietData.meal_scene_zh && dietData.meal_scene_zh.length"
              ><span class="select-title">日常用餐场景：</span>
              <span
                v-for="(item, index) in dietData.meal_scene_zh"
                :key="index"
                >{{
                  index < dietData.meal_scene_zh.length - 1 ? item + '、' : item
                }}</span
              ></div
            >
            <div
              class="select-info-item"
              v-if="dietData.meal_habit_zh && dietData.meal_habit_zh.length"
            >
              <span class="select-title">特殊饮食习惯：</span
              ><span
                v-for="(item, index) in dietData.meal_habit_zh"
                :key="index"
                >{{
                  index < dietData.meal_habit_zh.length - 1 ? item + '、' : item
                }}</span
              ></div
            >
            <div class="select-info-item" v-if="dietData.is_helpful_zh"
              ><span class="select-title">认为本餐对减脂是否有帮助：</span
              ><span>{{ dietData.is_helpful_zh }}</span></div
            >
          </div>
          <!-- 用户新人问卷填写信息 -->
          <div class="que-container" v-if="questionData">
            <div class="que-item" v-if="questionData.gender"
              ><span>性别:</span
              ><span>{{ questionData.gender == 1 ? '男' : '女' }}</span></div
            >
            <div class="que-item" v-if="questionData.age"
              ><span>年龄:</span><span>{{ questionData.age }}</span></div
            >
            <div class="que-item" v-if="questionData.height"
              ><span>身高:</span><span>{{ questionData.height }}CM</span></div
            >
            <div class="que-item" v-if="questionData.weight"
              ><span>体重:</span><span>{{ questionData.weight }}KG</span></div
            >
            <div class="que-item" v-if="questionData.bmi"
              ><span>BMI:</span><span>{{ questionData.bmi }}</span></div
            >
            <div class="que-item" v-if="questionData.nutritional_goal_weight"
              ><span>目标体重:</span
              ><span>{{ questionData.nutritional_goal_weight }}KG</span></div
            >
            <div class="que-item" v-if="questionData.illness"
              ><span>疾病:</span><span>{{ questionData.illness }}</span></div
            >
            <div class="que-item" v-if="questionData.user_type_name"
              ><span>体质:</span
              ><span>{{ questionData.user_type_name }}</span></div
            >
          </div>
          <UserTag :tag="userTagJavaData" />
          <div class="diet-time">{{ dietData.addTime | filterTime }}</div>
        </div>
      </div>
      <div class="space"></div>
      <!-- 点评内容 -->
      <div class="c-bottom">
        <!--  <AiNavComponent v-model="curActive" /> -->
        <div v-show="curActive == 0">
          <div v-if="showReviewResult">
            <StepThree
              v-if="!dietData.extra_meal_card_comment && showReviewResult"
              :autoShow="true"
              :data="reviewResult"
              :labelData="reviewResult.labelData"
            ></StepThree>
            <div
              v-if="
                dietData.extra_meal_card_comment && dietData.is_comment == 1
              "
            >
              <div class="review-bottom">
                <div class="coach-info">
                  <img class="avatar" :src="dietData.p_img" />
                  <span class="coach-name">{{ dietData.p_name || '' }}</span>
                  <div class="flag-content">
                    <img
                      class="coach-flag"
                      src="https://cdnvue.gymcity.com.cn/uploads/f64ba6b28c32b85773836483c5333068.png"
                    />
                  </div>
                </div>
                <div class="info">
                  <span>{{ dietData.extra_meal_card_comment || '' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="commont-time" v-if="dietData.is_comment == 1">
            <span>点评时间：</span><span>{{ dietData.comment_time }}</span>
          </div>
        </div>
        <!-- <AiComment v-show="curActive == 1" :data="dietData.ai_data" /> -->
      </div>
      <!-- 点评按钮 -->
      <div v-if="showStep">
        <div class="review-btn" v-if="!dietData.is_comment" @click="bindReview">
          <span>{{ (data.active + 1) | filterActive }}</span
          ><span class="num">({{ data.active + 1 }}/3)</span>
        </div>
        <div class="review-btn" v-else @click="bindDelete"> 删除点评 </div>
        <van-overlay
          class="review-overlay"
          :show="showPopUp"
          @click="showPopUp = false"
          :lock-scroll="false"
          :z-index="2000"
        >
          <ReviewStep
            v-if="dietData && data.labelData.length"
            ref="reviewstep"
            v-model="showPopUp"
            :dietData="dietData"
            :data="data"
            @save="bindSave"
            @release="bindRelease"
            @change="bindStepChange"
          ></ReviewStep>
        </van-overlay>
      </div>
      <div v-else class="extra-container">
        <div class="extra-btn" v-if="!dietData.is_comment" @click="bindReview"
          >点评</div
        >
        <div class="extra-btn" v-else @click="bindDelete">删除点评</div>
        <van-overlay
          class="review-overlay"
          :show="showPopUp"
          @click="showPopUp = false"
          :lock-scroll="false"
          :z-index="2000"
        >
          <ExtraComponent
            v-if="dietData"
            v-model="showPopUp"
            :dietData="dietData"
            :data="data"
            @save="bindSave"
            @release="bindRelease"
          ></ExtraComponent>
        </van-overlay>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import TagList from './components/tag-list.vue'
import ReviewStep from './components/review-step.vue'
import StepThree from './components/step-three.vue'
import AiComment from './components/ai-comment.vue'
import AiNavComponent from './components/ai-nav.vue'
import { scoreData } from './components/step-one/data'
import { ImagePreview } from 'vant'
import { reviewData, observeReviewData, deepClone } from './data'
import ExtraComponent from './components/extra.vue'
import UserTag from './components/user-tag.vue'
export default {
  name: 'not-camp-review-tool-detail',
  components: {
    AppNavbar,
    TagList,
    ReviewStep,
    StepThree,
    ExtraComponent,
    UserTag,
    AiComment,
    AiNavComponent
  },
  data() {
    return {
      showFixedInput: false,
      isWx: false,
      options: {
        title: '餐卡点评'
      },
      id: '',
      curActive: 0,
      showPopUp: false,
      dietData: null,
      defaultCommentParams: {
        p_average_score: 100
      },
      openTag: false, //是否打开标签
      sevenTagData: {
        //七日用户标签
        openTag: false,
        list: []
      },
      userTagData: {
        openTag: false,
        list: []
      }, //用户标签数据
      userTagJavaData: [], //用户标签java
      recentDiet: [], //最近饮食
      associationData: null,
      questionData: null, //新人问卷数据
      questionOptions: [
        {
          label: '性别',
          key: '',
          value: ''
        },
        {
          label: '年龄',
          key: 'age',
          value: ''
        },
        {
          label: '身高',
          key: '',
          value: ''
        },
        {
          label: '体重',
          key: '',
          value: ''
        },
        {
          label: 'BMI',
          key: 'bmi',
          value: ''
        },
        {
          label: '目标体重',
          key: '',
          value: ''
        },
        {
          label: '疾病',
          key: '',
          value: ''
        },
        {
          label: '体质',
          key: '',
          value: ''
        }
      ],
      /*  */
      data: {
        active: -1,
        labelData: [], //标签数据
        scoreData: [], //点评分数数据
        //点评内容
        reviewData: [],
        dietaryAdvice: {
          name: '未来饮食建议',
          val: 'future_dietary_analysis',
          value: '',
          minlength: 20,
          maxlength: 1000,
          require: true
        },
        exceptionDesc: {
          name: '异常描述',
          val: 'anomaly_records',
          value: '',
          maxlength: 1000
        }
      },
      //点评的结果
      reviewResult: {
        labelData: [], //标签数据
        scoreData: [], //点评分数数据
        //点评内容
        reviewData: [],
        dietaryAdvice: {
          name: '未来饮食建议',
          val: 'future_dietary_analysis',
          value: '',
          minlength: 20,
          maxlength: 1000,
          require: true
        },
        exceptionDesc: {
          name: '异常描述',
          val: 'anomaly_records',
          value: '',
          maxlength: 1000
        }
      },
      isViewOriginal: false, //是否查看原图
      showStep: true,
      showReviewResult: false
    }
  },
  filters: {
    filterTime(str) {
      return str.replace(/-/g, '.')
    },
    filterActive(index) {
      return index == 0 ? '餐卡点评' : '继续点评'
    }
  },
  watch: {},
  created() {
    this.isWx = window.__wxjs_environment
    this.getQuery()
    this.cacheStorage = JSON.parse(this.getCoachReview(this.id))
    this.getLabelData()
    this.getDetail()
  },
  mounted() {},
  methods: {
    //获取用户标签
    getUserTag() {
      let params = {
        uid: this.dietData.unify_id
      }
      this.$http
        .postBaseApp('member/UserTag/getUserTag', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userTagData.list = res.data || []
          } else {
            this.$toast('获取用户标签失败')
          }
        })
        .catch(() => {})
    },
    //实时保存
    saveCoachReview(id, data) {
      localStorage.setItem('saveNotCampReviewById_' + id, JSON.stringify(data))
    },
    getCoachReview(id) {
      return localStorage.getItem('saveNotCampReviewById_' + id)
    },
    //删除保存的草稿
    removeCoachReview(id) {
      localStorage.removeItem('saveNotCampReviewById_' + id)
    },

    //监听data
    watchCacheData() {
      this.$watch(
        'data',
        () => {
          this.saveCoachReview(this.id, this.data)
        },
        {
          deep: true
        }
      )
    },
    //进入用户信息界面
    bindIntoUserInfo() {
      //前往小程序个人主页
      wx.miniProgram.navigateTo({
        url:
          '/package-ugc/pages/circleUserInfo/circleUserInfo' +
          '?unify_id=' +
          this.dietData.unify_id
      })
    },
    bindStepChange(active) {
      if (active > this.data.active) {
        this.data.active = active
      }
    },
    bindOpenTag(data) {
      data.openTag = !data.openTag
    },
    formatImageUrl(imageUrl) {
      if (imageUrl.indexOf('_heic_')) {
        imageUrl = imageUrl + '/format,png'
      }
      return imageUrl
    },
    getQuery() {
      this.id = this.$route.query.id
    },
    bindChangeCommentType(index) {
      this.curActive = index
    },
    bindReview() {
      if (this.data.active == -1) {
        this.data.active = 0
      }
      this.showPopUp = true
    },
    getLabelData() {
      this.$http
        .postApp('api/v1/NutritionServicesComment/getCommentTagList', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (!this.data.labelData.length) {
              this.data.labelData = this.dealTagData(res.data)
            }
            this.reviewResult.labelData = this.dealTagData(res.data)
            if (this.dietData && this.dietData.p_label) {
              this.initTagData(this.dietData, this.data.labelData)
              this.initTagData(this.dietData, this.reviewResult.labelData)
            }
          }
        })
    },
    //处理获取到的标签
    dealTagData(data) {
      let cloneData = deepClone(data)
      cloneData.map((item) => {
        item.list.map((item1) => {
          item1.checked = false
        })
      })
      return cloneData
    },
    initCommentData(data, resultData) {
      //主食等点评内容
      resultData.reviewData.map((item) => {
        if (data[item.val]) {
          item.value = data[item.val]
        }
      })
      //未来建议
      if (data[resultData.dietaryAdvice.val]) {
        resultData.dietaryAdvice.value = data[resultData.dietaryAdvice.val]
      }
      //异常描述
      if (resultData.exceptionDesc && data[resultData.exceptionDesc.val]) {
        resultData.exceptionDesc.value = data[resultData.exceptionDesc.val]
      }
    },
    getDetail() {
      let params = {
        meal_id: this.id
      }
      this.$http
        .getApp('api/v1/NutritionServicesComment/getMealDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.truename = this.$route.query.truename
            res.data.nickname = this.$route.query.nickname
            res.data.head_img = this.$route.query.head_img
            res.data.addTime = res.data.created_at
            this.dietData = this.dealMealData(res.data)
            this.getUserTag()
            this.getUserJavaTag()
            this.getWeekDietTag()
            this.getQuestionData()
            //如果本地有草稿则获取并显示
            if (this.cacheStorage) {
              if (this.cacheStorage.labelData.length) {
                this.data = this.cacheStorage
              } else {
                //处理异常情况，如果缓存中的标签不存在，说明上次进入点评时因为接口问题未获取到标签列表，所以缓存不覆盖原来的数据
                let labelData = this.data.labelData
                this.data = this.cacheStorage
                this.data.labelData = labelData
              }
            } else {
              this.data.scoreData = this.initScoreData(this.dietData) //根据后台数据初始化分数
              this.initReviewData(this.dietData, this.data)
            }
            this.getCommentDetail()
            this.$nextTick(() => {
              if (this.dietData.p_cid) {
                this.data.active = 2
              }
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log('err', e)
        })
    },
    async getQuestionData() {
      let params = {
        unify_id: this.dietData.unify_id
      }
      let res = await this.$http
        .getApp(
          'api/v1/NutritionServicesComment/getNewUserQuestionnaire',
          params
        )
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.questionData = res.data
        }
      }
    },
    async getCommentDetail() {
      let params = {
        meal_id: this.id
      }
      let res = await this.$http
        .getApp('api/v1/NutritionServicesComment/getMealCommentDetail', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data && !Array.isArray(res.data)) {
            this.dietData = Object.assign({}, this.dietData, res.data)
            this.showReviewResult = true
            this.data.scoreData = this.initScoreData(this.dietData) //根据后台数据初始化分数
          }
          this.reviewResult.scoreData = this.initScoreData(this.dietData)
          this.initReviewData(this.dietData, this.reviewResult)
          this.initTagData(this.dietData, this.reviewResult.labelData)
          this.initTagData(this.dietData, this.data.labelData)
          if (!this.cacheStorage) {
            this.initCommentData(this.dietData, this.data)
          }
          this.initCommentData(this.dietData, this.reviewResult)
        }
        this.watchCacheData()
      }
    },
    dealMealData(data) {
      data.meal_img = data.meal_img.split(',')
      data.is_comment = 0
      return data
    },
    //根据后台数据初始化分数
    initScoreData(data) {
      let resultData = deepClone(scoreData)
      resultData.map((item) => {
        item.list.map((item1) => {
          if (data[item1.val] || data[item1.val] === 0) {
            item1.index = data[item1.val] - 1
          }
        })
      })
      this.computedScore(resultData)
      return resultData
    },
    //计算分数 以及初始化禁用状态
    computedScore(data) {
      data.map((item, index) => {
        let score = item.maxScore
        let indexList = [] //存放要禁用的index;
        item.list.map((item1, index1) => {
          if (item1.index >= 0) {
            score += item1.select[item1.index].less
          }
          /* 判断是否禁用其他选项 */
          item1.select.map((seitem, seindex) => {
            if (seitem.disabledOther && item1.index == seindex) {
              indexList.push(index1)
            }
          })
        })
        if (indexList.length) {
          item.list.map((item1, index1) => {
            if (!indexList.includes(index1)) {
              item1.disabled = true
            }
          })
        }
        item.score = score
      })
      return data
    },
    //根据后端数据初始化标签选中状态
    initTagData(data, resultData) {
      if (!data || !resultData.length) {
        return
      }
      let obj = {}
      if (data.p_label) {
        data.p_label.map((item) => {
          obj[item.id] = true
        })
      }
      resultData.map((item, index) => {
        item.list.map((item1) => {
          if (obj[item1.id]) {
            item1.checked = true
          }
        })
      })
    },
    //根据餐卡类型决定哪些需要显示
    initReviewData(data, resultData) {
      //观察期打卡
      if (data.p_type == 7) {
        resultData.exceptionDesc = null
        resultData.reviewData = deepClone(observeReviewData)
      } else {
        resultData.reviewData = deepClone(reviewData)
      }
    },
    //预览图片
    previewImage(item, index) {
      if (!this.isViewOriginal) {
        item = item.map((item1) => {
          return (
            item1 + '?x-oss-process=image/resize,w_750/quality,Q_70/format,jpg'
          )
        })
      }
      ImagePreview({
        images: item,
        startPosition: index
      })
    },
    //删除点评
    bindDelete() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '是否要删除点评?'
        })
        .then(() => {
          this.deleteReview()
        })
        .catch(() => {
          // on cancel
        })
    },
    //删除点评接口
    deleteReview() {
      let params = {
        meal_id: this.id
      }
      this.$http
        .postApp(
          'api/v1/NutritionServicesComment/delCommentatorComment',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('删除成功')
            this.dietData.is_comment = 0
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    //保存点评
    bindSave() {
      this.bindSubmit(0)
    },
    //发布点评
    bindRelease() {
      this.bindSubmit(1)
    },
    bindSubmit(pshow) {
      let params = {
        meal_id: this.id,
        merit: this.getSelectTag('优点'), //优点
        defect: this.getSelectTag('缺点'), //缺点
        trait: this.getSelectTag('特点'), //特点
        special_nutrients: this.getSelectTag(
          '特殊营养素(仅作记录，不会展示在会员端)'
        ), //特点
        meal_type: this.dietData.meal_type,
        p_show: pshow,
        push_type: pshow
      }
      if (this.$route.query.curMeal == 3) {
        params.extra_meal_card_comment = this.dietData.extra_meal_card_comment
      }
      params = Object.assign(params, this.getSubmitParams())
      this.$http
        .postApp('api/v1/NutritionServicesComment/saveCommentDiet', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.removeCoachReview(this.id)
            this.$toast(pshow ? '发布成功' : '保存成功')
            if (pshow) {
              this.finishedComment(this.id)
            }
            this.$router.go(-1)
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //完成评论
    finishedComment(id) {
      localStorage.setItem('finishedCommentId', id)
    },
    //获取提交参数
    getSubmitParams() {
      let params = {}
      //评分
      this.data.scoreData.map((item) => {
        item.list.map((item1) => {
          params[item1.val] = item1.index + 1
        })
      })
      //点评内容
      this.data.reviewData.map((item) => {
        params[item.val] = item.value
      })
      //未来建议
      params[this.data.dietaryAdvice.val] = this.data.dietaryAdvice.value
      //异常描述
      if (this.data.exceptionDesc) {
        params[this.data.exceptionDesc.val] = this.data.exceptionDesc.value
      }
      return params
    },
    //获取选中的标签
    getSelectTag(str) {
      let res = []
      this.data.labelData.map((item) => {
        if (item.name == str) {
          item.list.map((item1) => {
            if (item1.checked) {
              res.push(item1.id)
            }
          })
        }
      })
      return res.join(',')
    },
    getWeekDietTag() {
      let params = {
        unify_id: this.dietData.unify_id
      }
      this.$http
        .postApp(
          'api/v1/NutritionServicesComment/getUserLatelySevenDaysLab',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.sevenTagData.list = this.sortTag(res.data)
          }
        })
    },
    //标签排序
    sortTag(list) {
      list.sort((a, b) => {
        {
          if (a.label_weight != b.label_weight) {
            //优先标签权重，权重不一致则权重高的排在前面
            return b.label_weight - a.label_weight
          } else {
            //权重一致则次数高的排在前面
            return b.label_num - a.label_num
          }
        }
      })
      return list
    },
    //获取开启结束等点评内容默认文案
    getReviewData(type, val) {
      if (this.reviewLoaded || this.dietData.p_cid || this.cacheStorage) {
        return
      }
      let params = {
        addtime: this.dietData.addtime,
        p_type: this.dietData.p_type,
        curMeal: this.$route.query.curMeal,
        unify_id: this.dietData.unify_id,
        postion_type: type
      }
      this.$http
        .getApp('member/NutritionistComments/getAllCommentRecommend', params)
        .then((res) => {
          res = res.data
          if (res.code == 200 && res.data) {
            this.data.reviewData.map((item) => {
              if (item.val == val) {
                item.value = res.data
              }
            })
            //饮食建议
            if (this.data.dietaryAdvice.val == val) {
              this.data.dietaryAdvice.value = res.data
            }
          }
          this.reviewLoaded = true
        })
    },
    async getUserJavaTag() {
      let params = {
        unify_id: this.dietData.unify_id
      }
      let res = await this.$http
        .getApp('api/v1/NutritionServicesComment/userTags', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.userTagJavaData = res.data || []
        } else {
          this.$toast('获取用户标签失败')
        }
      }
    }
  }
}
</script>
<style lang="scss">
.page-content {
  .van-tab {
    flex: 0 0 auto;
    padding: 0px 12px;
  }

  .van-tabs__line {
    width: 16px;
    height: 4px;
    background: #6236ff;
    border-radius: 2px;
  }

  .van-tab--active {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
  }
}
</style>
<style lang="scss" scoped>
.page-content {
  background: #fff;
  min-height: 100vh;
}

.container {
  padding-bottom: 100px;

  .c-top {
    background-color: #fff;
    padding-bottom: 19px;

    .c-padding {
      padding: 0px 20px;
      box-sizing: border-box;
    }

    .user-info {
      display: flex;
      align-content: center;
      margin-bottom: 8px;

      .avatar {
        width: 36px;
        height: 36px;
        border-radius: 6px;
        overflow: hidden;
        margin-right: 10px;
      }

      .user-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .name {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
        }

        .camp {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          line-height: 14px;

          .nickname {
            margin-right: 10px;
          }
        }
      }

      .user-calendar {
        padding: 10px;
      }
    }

    .tag-container {
      position: relative;
      margin-bottom: 14px;
      padding-bottom: 20px;

      .tag-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .tag-item {
          height: 24px;
          line-height: 24px;
          background: #f9f9f9;
          border-radius: 4px;
          padding: 0px 8px;
          margin-right: 8px;
          margin-bottom: 8px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;

          .tag-color-1 {
            color: #2bb79b;
          }

          .tag-color-2 {
            color: #f04646;
          }

          .tag-num {
            margin-left: 6px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            line-height: 14px;
          }
        }

        .user-tag-1 {
          background: linear-gradient(#fffef8 0%, #eefff4 100%);
        }

        .user-tag-2 {
          background: linear-gradient(#f9d5ff 0%, #ffe0e0 100%);
        }

        .user-tag-3 {
          background: linear-gradient(#faf8ff 0%, #eefbff 100%);
        }
      }

      .open-tag {
        position: absolute;
        right: 20px;
        bottom: 0;
        color: rgba(0, 0, 0, 0.5);

        .iconfont {
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          border-radius: 50%;
          background: #ffffff;
          border: 1px solid #f1f1f1;
          margin-left: 6px;
        }
      }
    }

    .maxheight {
      max-height: 28px;
      overflow: hidden;
    }

    .diet-image-container {
      width: 100%;
      overflow-y: scroll;
      margin-bottom: 16px;

      .d-list {
        display: inline-flex;
        align-items: center;
        padding: 0px 20px;

        .d-item {
          width: 150px;
          height: 150px;
          object-fit: cover;
          margin-right: 8px;
        }

        .d-item:last-child {
          margin-right: 0px;
        }
      }
    }

    .diet-info {
      .diet-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
        margin-bottom: 7px;
      }

      .diet-desc {
        white-space: pre-wrap;
        word-break: break-all;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 24px;
        margin-bottom: 16px;
      }

      .diet-time {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.3);
        line-height: 18px;
      }
    }
  }

  .space {
    height: 8px;
    background-color: #f9f9f9;
  }
}

.review-btn {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, 0%);
  width: 335px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #6236ff;
  border-radius: 10px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;

  .num {
    margin-left: 6px;
    font-size: 12px;
    color: rgba(194, 177, 255, 1);
  }
}

.overlay-content {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 2001;
}

.calendar {
  color: rgba(74, 61, 107, 1);
}

.review-overlay {
  background-color: rgba(0, 0, 0, 0.1);
}

.extra-container {
  .extra-btn {
    position: fixed;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%, 0%);
    width: 335px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #6236ff;
    border-radius: 10px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}

.commont-time {
  padding: 0px 16px;
  color: rgba(0, 0, 0, 0.6);
}

.c-bottom {
  padding: 20px 0px 0px;
  .review-bottom {
    padding: 9px 16px;
    border-radius: 0px 5px 5px 5px;

    .coach-info {
      display: flex;
      align-items: center;

      .avatar {
        flex: 0 0 22px;
        margin-right: 6px;
        width: 22px;
        height: 22px;
        border-radius: 5px;
      }

      .coach-name {
        font-size: 12px;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 8px;
      }

      .coach-flag {
        width: 68px;
      }
    }

    .info {
      margin-top: 5px;
      font-size: 12px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.6);
      word-break: break-all;
      word-wrap: break-word;
    }
  }
}
.select-info {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  .select-info-item {
    margin-bottom: 10px;
  }
  .select-title {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
  }
}
.que-container {
  border-top: 1px dashed rgba(0, 0, 0, 0.3);
  padding: 10px 0px 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .que-item {
    font-size: 12px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>
